import { ApplyModeConfig } from '@app/config';

let config = 
{
    AUTH_KEY: "iRLpOrsVGVZCcOiwIfk@/biK-]NjYio_"
};

config = ApplyModeConfig(config);

export default config;